"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OpenEndedQuestion;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _schemaStore = require("../../state/schema-store");

var _schemaReducer = require("../../state/schema-reducer");

var _languageStore = require("../../state/language-store");

function OpenEndedQuestion(_ref) {
  var _schema$properties$id;

  var id = _ref.id;

  var _useContext = (0, _react.useContext)(_schemaStore.SchemaContext),
      _useContext2 = (0, _slicedToArray2.default)(_useContext, 2),
      schema = _useContext2[0],
      schemaDispatch = _useContext2[1];

  var title = (schema === null || schema === void 0 ? void 0 : (_schema$properties$id = schema.properties[id]) === null || _schema$properties$id === void 0 ? void 0 : _schema$properties$id.title) || "";

  var _useContext3 = (0, _react.useContext)(_languageStore.LanguageContext),
      _useContext4 = (0, _slicedToArray2.default)(_useContext3, 1),
      language = _useContext4[0];

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    size: "small",
    fullWidth: true,
    label: "".concat(language.questionnaireInputTitleLabel),
    name: "text",
    type: "text",
    variant: "outlined",
    onChange: function onChange(e) {
      return schemaDispatch({
        type: _schemaReducer.TYPES.UPDATE_QUESTION_TITLE,
        payload: {
          index: id,
          title: e.target.value
        }
      });
    },
    value: title
  }));
}